<template>
  <a-modal
    :title="readOnly ? '详情' : (formData.id ? '编辑' : '新增')"
    :width="600"
    :visible="visible"
    @cancel="onClose"
    @ok="onConfirm"
    :dialog-style="{ top: '8px' }"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="loading">
      <a-form-model
        ref="ruleForm"
        :model="formData"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="加工组织" prop="organizationCode" :rules="inputNeedRule">
          <global-select
            v-model="formData.organizationCode"
            requestApi="/system/user/inventOrgAll"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :disabled="isDisableOrganization"
            :assembleLabel="true"
            @change="onChangeOrganization"
          />
        </a-form-model-item>
        <a-form-model-item label="SPU" prop="itemName" :rules="inputNeedRule">
          <a-input v-model="formData.itemName" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item label="规格" prop="specification" :rules="inputNeedRule">
          <a-input v-model="formData.specification" :maxLength="100" />
        </a-form-model-item>
        <a-form-model-item label="成品SKU" prop="itemCode">
          <global-select
            v-model="formData.itemCode"
            selectType="selectAssembleSearch"
            :dropdown-match-select-width="false"
            requestApi="/mdm/mdmItemSystemItem/selectItemCodeBox"
            :selectItem="{ value: 'selectedValue', label: 'label' }"
            :setParams="{ itemType: 'CP' }"
            searchParam="itemCode"
            sourseField="res"
            :totalNum="9999999999"
            @change="(value, list) => onChangeItemCode(value, list, record)"
          />
        </a-form-model-item>
        <a-form-model-item label="净用量" prop="zpReferenceScale" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.zpReferenceScale" :precision="2" />
        </a-form-model-item>
        <a-form-model-item label="真皮工价" prop="zpWages" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.zpWages" :precision="2" />
        </a-form-model-item>
        <a-form-model-item label="真皮省/超尺工价" prop="zpPoLaborWages" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.zpPoLaborWages" :precision="2" />
        </a-form-model-item>
        <a-form-model-item label="仿皮工价" prop="fpWages" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.fpWages" :precision="2" />
        </a-form-model-item>
        <a-form-model-item ref="mbWages" label="面布工价" prop="mbWages" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.mbWages" :precision="2" />
        </a-form-model-item>
        <a-form-model-item label="生态皮/硅胶皮/西皮工价" prop="otWages" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.otWages" :precision="2" />
        </a-form-model-item>
        <a-form-model-item label="辅料布工价" prop="fbWages" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.fbWages" :precision="2" />
        </a-form-model-item>
        <a-form-model-item label="丝绵工价" prop="smWages" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.smWages" :precision="2" />
        </a-form-model-item>
        <a-form-model-item ref="blWages" label="补料工价" prop="blWages" :rules="[positiveNumRule]">
          <a-input-number v-model="formData.blWages"  :precision="2" />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input v-model="formData.remark" :maxLength="200" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { addBomSalaryUnitPriceCc, updateBomSalaryUnitPriceCc } from "@/api/mes/productionPrepare/pieceWageUnitPrice";
import { mapState } from 'vuex'
import { positiveNumValidate } from '../common';

// 表单字段
export default {
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      readOnly: false,
      visible: false,
      loading: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      // 表单属性:
      formData: this.getInitData(),
      baseNeedRule: { required: true, message: " ", trigger: "change" },
      inputNeedRule: { required: true, message: " ", trigger: "blur", whitespace: true },
      positiveNumRule: { validator: positiveNumValidate }
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'; // 林氏产业园库存组织可
    }
  },
  methods: {
    // 由于要用传进来的值做判断,将显示和隐藏放在内部做处理
    show (data, readOnly) {
      this.formData = this.getInitData();
      if (data) {
        this.formData = Object.assign({}, data)
      }
      this.readOnly = !!readOnly;
      this.visible = true;
      this.confirmLoading = false;
    },
    onChangeOrganization() {
      this.formData.itemCode = undefined;
    },
    // 关闭模态框
    onClose () {
      this.visible = false
      this.formData = this.getInitData()
    },
    onConfirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.formData.id) {
            // 刷新表格
            this.confirmLoading = true;
            updateBomSalaryUnitPriceCc(this.formData).then(response => {
              if (response.code === 200) {
                this.$message.success('修改成功')
                this.$emit('successCall')
                this.onClose();
              } else {
                this.$message.error(response.msg)
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          } else {
            // 新增
            this.formData.enable = 1;
            this.confirmLoading = true;
            addBomSalaryUnitPriceCc(this.formData).then(response => {
              if (response.code === 200) {
                this.$message.success('新增成功');
                // 关闭本组件
                this.visible = false;
                // 调用外部刷新列表方法
                this.$emit('successCall');
                // 刷新表单
                this.formData = this.getInitData();
              } else {
                this.$message.error(response.msg);
              }
            }).finally(() => {
              this.confirmLoading = false;
            })
          }
        }
      })
    },
    // 表单重置
    getInitData () {
      return {
        id: undefined,
        organizationCode: this.isDisableOrganization ? this.organizationCodeOrigin : undefined,
        itemName: undefined,
        specification: undefined,
        itemCode: undefined,
        specificationDesc: undefined,
        zpReferenceScale: undefined,
        zpWages: undefined,
        zpPoLaborWages: undefined,
        fpWages: undefined,
        mbWages: undefined,
        otWages: undefined,
        fbWages: undefined,
        smWages: undefined,
        blWages: undefined,
        remark: undefined
      }
    }
  }
}
</script>
<style lang="less" scoped>
  /deep/.ant-form-explain {
    position: absolute;
    font-size: 12px;
    line-height: 1.5em;
  }
  /deep/.ant-form-item {
    margin: 0 0 12px 0;
  }
</style>
